import { fetchAuthSession } from '@aws-amplify/auth';
import { API_BASE } from './apiBase';

const ORGANIZATION_KEY = 'factor-listings:organization';
let activeProfile = null;
export function selectedOrganization() {
  return sessionStorage.getItem(ORGANIZATION_KEY) || null;
}
export function selectOrganization(id) {
  activeProfile = null;
  if (id) sessionStorage.setItem(ORGANIZATION_KEY, id);
  else sessionStorage.removeItem(ORGANIZATION_KEY);
}
export function setActiveProfile(profile) {
  activeProfile = profile;
  if (profile) sessionStorage.setItem(ORGANIZATION_KEY, profile.organizationId);
}
/** Credentials go only to this app's API, never to PDF, map, or presigned storage URLs. */
export async function apiFetch(url, options = {}) {
  const isApiUrl = url === API_BASE || url.startsWith(`${API_BASE}/`);
  const target = !isApiUrl && url.startsWith('/') ? `${API_BASE}${url}` : url;
  if (target !== API_BASE && !target.startsWith(`${API_BASE}/`)) {
    throw new Error('Authenticated requests must use the Listings API');
  }
  const organizationId = selectedOrganization();
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Sign in to continue');
  return fetch(target, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      ...(organizationId ? { 'x-organization-id': organizationId } : {}),
    },
  });
}
/** Report preferences and titles stay with their authenticated actor and organization. */
export const reportStorage = {
  getItem(key) {
    return activeProfile
      ? localStorage.getItem(
          `listing-reports:${activeProfile.organizationId}:${activeProfile.app_user_id}:${key}`,
        )
      : null;
  },
  setItem(key, value) {
    if (activeProfile)
      localStorage.setItem(
        `listing-reports:${activeProfile.organizationId}:${activeProfile.app_user_id}:${key}`,
        value,
      );
  },
};
